import { useEffect } from "react";

export default function ErrorPopup({
  message,
  onClose,
  type = "error",
}) {

  useEffect(() => {
    if (!message) return;

    const timer = setTimeout(() => {
      onClose();
    }, 3000);

    return () => clearTimeout(timer);
  }, [message, onClose]);

  if (!message) return null;

  const tone =
    type === "success"
      ? "bg-green-600"
      : type === "info"
        ? "bg-[#2b3896]"
        : type === "warning"
          ? "bg-amber-600"
          : "bg-red-600";

  return (
    <div
      className={`fixed top-5 right-5 max-w-[min(92vw,28rem)] ${tone}
      text-white px-5 py-3 rounded-lg shadow-xl
      z-[99999] flex items-center gap-3`}
    >
      <span className="text-sm font-medium">{message}</span>

      <button
        onClick={onClose}
        className="font-bold text-white ml-2"
      >
        ✕
      </button>
    </div>
  );
}